import * as Sentry from '@sentry/vue'
import { useOneSignal } from '@onesignal/onesignal-vue3'

class OneSignalService {
  private oneSignal

  constructor() {
    try {
      this.oneSignal = useOneSignal()
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  login(userId: string): void {
    try {
      if (!this.oneSignal) return
      this.oneSignal.login(userId)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  addTag(key: string, value: string): void {
    try {
      if (!this.oneSignal) return
      this.oneSignal.User.addTag(key, value)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  addEmail(email: string): void {
    try {
      if (!this.oneSignal) return
      this.oneSignal.User.addEmail(email)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  logout(): void {
    try {
      if (!this.oneSignal) return
      this.oneSignal.logout()
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  setConsentGiven(consent: boolean): void {
    try {
      if (!this.oneSignal) return
      this.oneSignal.setConsentGiven(consent)
    } catch (error) {
      Sentry.captureException(error)
    }
  }
}

export const oneSignalService = new OneSignalService()
